import UI_Layout from "../../layout/ui-layout";
import {NavigationBackground, SkinTheme, UIType} from "../@const";
import {GoodDayUserInterface} from "../ui";
import NavigationPanel_Classic_User from "./navigation-panel/user";


export class GoodDayLeft extends GoodDayUserInterface {

    constructor() {
        super({
            type        : UIType.LEFT
        })
    }

    // Navigation Panel

    get NavigationPanelUserComponent():any {
        return NavigationPanel_Classic_User
    }




    get layoutCSSClass():string {
        return "ui-layout left-nav"
    }

    get LayoutClass() {
        return UI_Layout
    }

    get navigationPanelMainClass() {

        let classes = "ui-navigation left-nav"

        let navigationColorTheme: NavigationBackground = gd.user.settings.skin.navigation

        switch (gd.skin.layoutTheme) {
            case SkinTheme.DARK:
                classes += ' theme-dark-'+ navigationColorTheme
                break

            case SkinTheme.LIGHT:
            default:
                classes += ' theme-light-'+ navigationColorTheme
                break
        }

        return classes
    }

    get leftNavigationPanelSize(): number {
        return 54
    }

    get hasContrastSettings():boolean {
        return this.isLight
    }
}
